//#region IMPORT
/** Components Import */
import { Unstable_Grid2 as Grid } from '@mui/material';
import { AuthButton, Button } from '../../../../Components/MUIs';

/** AG-grid Import */
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { BusinessCommon } from '../../../../Components/BusinessCommon';
import { GridFileUploadF } from '../../../../Components/Ui/GridFileUpload/GridFileUploadF';
import { getColumnDefs1 } from './EMR_BASIC_ColumnDefs';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
/** Icons Import */
import dayjs from 'dayjs';
//#endregion

function EMR_BASIC(props) {
  //#region 변수
  const columnDefs1 = getColumnDefs1(props);
  //#endregion

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="EmergencyManual"
          searchYn="Y"
          addYn="Y"
          saveYn="Y"
          printYn="N"
          saveClick={(e) => {
            if (!props.validateSelection()) return;

            props.SaveLogic1();
          }}
          conditions={[
            {
              type: 'datePicker',
              title:
                props.lanInfo.length === 0
                  ? ''
                  : props.lanInfo.find(
                      (f) => f.lanType !== 'MENU' && f.lanId === 'Period'
                    )?.lanNm || '', //기간
              name: '조회일자(시작)',
              value: dayjs(props.startDate),
              onChange: (date) => {
                props.ResetLogic1();
                if (!props.validateSelection()) return;
                props.handleStartDateChange(date);
                props.SearchLogic1();
              },
              currentLocale: 'ko',
            },
            {
              type: 'datePicker',
              title:
                props.lanInfo.length === 0
                  ? ''
                  : props.lanInfo.find(
                      (f) => f.lanType !== 'MENU' && f.lanId === 'Period'
                    )?.lanNm || '', //기간
              name: '조회일자(끝)', //기간
              value: dayjs(props.endDate),
              onChange: (date) => {
                props.ResetLogic1();
                if (!props.validateSelection()) return;
                props.handleEndDateChange(date);
                props.SearchLogic1();
              },
              currentLocale: 'ko',
            },
            // ADMIN이면 추가 combo
            ...(props.userInfo.authCd === 'ADMIN'
              ? [
                  {
                    type: 'combo',
                    name: '회사',
                    items: props.searchInfo.coList,
                    value: props.searchInfo.coCd,
                    onChange: (e) => {
                      props.handleCoChange(e);

                      props.ResetLogic1();
                      if (!props.validateSelection()) return;

                      props.SearchLogic1();
                    },
                  },
                ]
              : []),
            {
              type: 'combo',
              name: '사업장',
              items: props.searchInfo.custList,
              value: props.searchInfo.custCd,
              onChange: (e) => {
                props.ResetLogic1();
                if (!props.validateSelection()) return;

                props.handleCustChange(e);

                props.SearchLogic1();
              },
            },
          ]}
          grids={
            <BusinessCommon
              title1={'비상대응매뉴얼 기본정보'}
              title2={'비상대응매뉴얼 미리보기'}
              gridId={props.gridId1}
              getRowId={(params) => {
                return params.data.no;
              }}
              addClick1={() => {
                GridFileUploadF('', props.gridRef1, props, {
                  blockVideo: true,
                });
              }}
              refreshClick1={() => {
                props.SearchLogic1();
              }}
              deleteClick1={(e) => {
                if (!props.validateSelection()) return;

                const newRowExists = props.selectedRowData1.some(
                  (row) => row.newYn === 'Y'
                );

                if (!newRowExists) {
                  props.MarkedForDeletion1(props.selectedRowData1);
                } else {
                  props.NewYnErrorMsg();
                }
              }}
              gridRef={props.gridRef1}
              columnDefs={columnDefs1}
              rowData={props.rowData1}
              setSelectedRowData={props.setSelectedRowData1}
              setChangedRowData={props.setChangedRowData1}
              rowSelection={'multiple'}
              onCellClicked={(e) => {
                const gridApi = props.gridRef1.current.api;
                const clickedRowIndex = e.rowIndex;

                const isCheckboxClick = e.event?.target?.type === 'checkbox';
                // 앱 공유 컬럼 클릭 시 행 선택 로직이 체크를 방해하지 않도록 제외
                if (isCheckboxClick || e.colDef?.field === 'appShareYn') {
                  return;
                }

                gridApi.ensureIndexVisible(clickedRowIndex, 'middle');

                const copied = JSON.parse(JSON.stringify(e.data));
                props.handleRowSelection1(copied, clickedRowIndex);

                gridApi
                  .getDisplayedRowAtIndex(clickedRowIndex)
                  ?.setSelected(true, false);
              }}
              onSelectionChanged={() => {
                const gridApi = props.gridRef1?.current?.api;
                const selectedNodes = gridApi.getSelectedNodes();
                const selectedData = selectedNodes.map((n) => n.data);
                props.selectedRowNosRef1.current = new Set(
                  selectedData.map((r) => r.no)
                );
                props.setSelectedRowData1(selectedData);
              }}
              onCellValueChanged={(e) => {
                GridFunctions.onCellValueChanged(
                  e,
                  props.gridRef1,
                  props.setChangedRowData1
                );
              }}
              viewMode="preview"
              selectedRowData={props.selectedRowData1}
              fileNameField="saveName"
              filePathField="filePath"
              other1={
                <>
                  <Button
                    name="서식 다운로드"
                    onClick={() => {
                      if (!props.validateSelection()) return;

                      props.DownloadLogic1();
                    }}
                  />
                  {/* 멀티 다운로드 훅으로 빼야함 */}
                  <Button
                    name="멀티 다운로드"
                    onClick={() => {
                      if (!props.validateSelection()) return;

                      if (props.selectedRowData1?.length === 0) {
                        props.dispatch(
                          props.showSnackbar({
                            message: '다운로드할 항목을 먼저 선택해 주세요.',
                            type: 'warning',
                          })
                        );

                        return;
                      }

                      props.selectedRowData1.forEach((item, index) => {
                        setTimeout(() => {
                          props.DownloadLogic2(item);

                          // 마지막 항목일 때만 메시지 출력
                          // if (index === props.selectedRowData1.length - 1) {
                          //   setTimeout(() => {
                          //     props.dispatch(props.showSnackbar({ message: '모든 파일 다운로드 완료', type: 'success' }));
                          //   }, 500);
                          // }
                        }, index * 300);
                      });
                    }}
                  />
                </>
              }
            />
          }
        />
      </Grid>
    </Grid>
  );
}

export default EMR_BASIC;
